import './cartEmpty.scss';

import { FormattedMessage } from 'react-intl';

const EmptyCartIllustration = () => (
  <svg
    aria-hidden
    fill='none'
    height='56'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2.2'
    viewBox='0 0 64 64'
    width='56'
  >
    <path d='M6 10h6l6 32a4 4 0 004 3h20a4 4 0 004-3l4-22H16' />
    <circle cx='22' cy='54' r='3' />
    <circle cx='44' cy='54' r='3' />
  </svg>
);

const CartEmpty = () => (
  <div className='CartEmpty'>
    <div aria-hidden className='CartEmpty_illustration'>
      <EmptyCartIllustration />
    </div>
    <h3 className='CartEmpty_title'>
      <FormattedMessage defaultMessage='Your cart is empty' id='cartEmptyTitle' />
    </h3>
    <p className='CartEmpty_body'>
      <FormattedMessage
        defaultMessage='Browse the catalog and add your first products to start your order.'
        id='cartEmptyBodyDrawer'
      />
    </p>
  </div>
);

export default CartEmpty;
